export const documents = [
	{ id: 1, name: "Requerimento MEI" },
	{ id: 2, name: "Extratos bancários últimos 6 meses de conta corrente PF" },
	{ id: 3, name: "Certidão de Casamento com averbação de separação" },
	{
		id: 4,
		name: "Contracheque (via Empregador) dos 02 últimos meses, emitido no site",
	},
	{
		id: 5,
		name: "Extrato da Conta Bancária demonstrando o Crédito da Pensão Judicial/Alimentícia",
	},
	{ id: 6, name: "Pró-labore" },
	{ id: 7, name: "Simples Nacional" },
	{
		id: 8,
		name: "Retrato Funcional ou Termo de Posse ou Histórico Funcional",
	},
	{ id: 9, name: "IRPJ" },
	{ id: 10, name: "DIRPF Completa (Recibo+Declaração) do último exercício" },
	{ id: 11, name: "IRPF com recibo de entrega" },
	{ id: 12, name: "Recibo de pagamento da instituição de vínculo" },
	{ id: 13, name: "Carteira Funcional" },
	{ id: 14, name: "Termos Aditivos/renovações" },
	{ id: 15, name: "Contrato de Estágio vigente" },
	{ id: 16, name: "Contrato social e alterações" },
	{ id: 17, name: "CNH" },
	{
		id: 18,
		name: "Detalhamento de Crédito do INSS dos 02 últimos  meses, emitido no site do INSS",
	},
	{
		id: 19,
		name: "Retrato Funcional ou Termo de Posse ou Boletin Informativo (BI) para Soldado",
	},
	{ id: 20, name: "Certidão de casamento" },
	{ id: 21, name: "RG" },
	{ id: 22, name: "ESTRANGEIRO" },
	{ id: 23, name: "Extrato de FGTS" },
	{ id: 24, name: "CTPS" },
	{ id: 25, name: "Ficha de Renda Informal" },
	{ id: 26, name: "Certidão de Casamento com averbação de divórcio" },
	{ id: 27, name: "Extrato da conta bancária demonstrando o crédito" },
	{ id: 28, name: "Retificadoras do IRPF" },
	{ id: 29, name: "Contrato Social consolidado" },
	{ id: 30, name: "Certidão de Casamento com averbação de óbito do cônjuge" },
	{ id: 31, name: "Despesas em nome do cliente" },
	{ id: 32, name: "Certidão de nascimento" },
	{ id: 33, name: "Enquadramento PCVA" },
	{ id: 34, name: "02 últimos contracheques" },
	{ id: 35, name: "Sentença que homologou a decisão judicial" },
	{ id: 36, name: "Certidão de Nascimento do Filho" },
	{ id: 37, name: "Declaração da Faculdade que o filho está cursando;" },
	{ id: 38, name: "Declaração da Faculdade que o filho está cursando" },
	{ id: 39, name: "Declaração de Moradia Compartilhada, assinada por ambos" },
	{ id: 40, name: "Comprovante de Residência do parente" },
	{
		id: 41,
		name: "Documentos Pessoais do parente (incluindo cópia da CTPS para comprovar que o parente não possui renda)",
	},
	{ id: 42, name: "Escritura de União Estável" },
	{ id: 43, name: "Documentos Pessoais do(a) Companheiro(a)" },
	{ id: 44, name: "Decisão judicial de concessão da guarda" },
	{ id: 45, name: "Documento pessoal de identificação do parente" },
	{
		id: 46,
		name: "Declaração da faculdade atestando o curso que o parente está matriculado, caso o parente tenha mais de 21 e até 24 anos, ou declaração médica atestando a incapacidade física/mental para o trabalho",
	},
	{ id: 47, name: "Pacto Antenupcial" },
	{ id: 48, name: "Passaporte" },
	{ id: 49, name: "Carteira de trabalho" },
];

export interface IQuestion {
	label: string;
	field?: string;
	fields?: string[];
}

export const questions: IQuestion[] = [
	{ label: "Nome do proponente", field: "nomeCompleto" },
	{ label: "CPF do proponente", field: "cpf" },
	{ label: "Empréstimo/Financiamentos", field: "emprestimosFinancimanentos" },
	{ label: "Financiamento Habitacional", field: "habitacional" },
	{ label: "Nome formato reduzido", field: "nomeReduzido" },
	{ label: "Sexo", field: "cmbSexo" },
	{ label: "Nome do pai", field: "nomePai" },
	{ label: "Nome da mãe", field: "nomeMae" },
	{ label: "Nacionalidade", field: "cmbNacionalidade" },
	{ label: "Estado", field: "cmbUFNaturalidade" },
	{ label: "Cidade", field: "cmbMunicipioNaturalidade" },
	{ label: "País", field: "cmbPaisDeNacionalidade" },
	{ label: "Grau de instrução", field: "cmbGrauInstrucao" },
	{ label: "PIS/NIS", field: "pis" },
	{ label: "Tipo de documento de identificação", field: "cmbTipoDocumento" },
	{
		label: "Número da carteira nacional de habilitação",
		field: "identidadeNumeroCnh",
	},
	{ label: "Data 1ª habilitação", field: "dataPrimeiraHabilitacaoCnh" },
	{ label: "Órgão emissor CNH", field: "cmbOrgaoEmissorCnh" },
	{ label: "Órgão emissor PASSAPORTE", field: "cmbOrgaoEmissorPassaporte" },
	{ label: "Órgão emissor RG", field: "cmbOrgaoEmissorRg" },
	{ label: "Número do passaporte", field: "identidadeNumeroPassaporte" },
	{ label: "Número de identidade", field: "identidadeNumeroRg" },
	{ label: "Subtipo de documento", field: "subTipoIdentidadeNumeroRg" },
	{ label: "Número da identidade", field: "identidadeNumeroRg" },
	{ label: "UF identidade CNH", field: "cmbUFIdentidadeCnh" },
	{ label: "UF identidade PASSAPORTE", field: "cmbUFIdentidadePassaporte" },
	{ label: "UF identidade RG", field: "cmbUFIdentidadeRg" },
	{ label: "UF endereço", field: "cmbUFEndereco" },
	{
		label: "Data de emissão (CNH, RG ou PASSAPORTE)",
		fields: [
			"dataEmissaoIdentidadeRg",
			"dataEmissaoIdentidadeCnh",
			"dataEmissaoIdentidadePassaporte",
		],
	},
	{
		label: "Data fim de validade (CNH, RG ou PASSAPORTE)",
		fields: [
			"dataFimValidadeRg",
			"dataFimValidadeCnh",
			"dataFimValidadePassaporte",
		],
	},
	{ label: "Estado civil", field: "cmbEstadoCivil" },
	{ label: "CPF do cônjuge", field: "cpfConjuge" },
	{ label: "Tipo de ocupação", field: "cmbTpOcupacao" },
	{ label: "Ocupação", fields: ["cmbOcupacaoInformal", "cmbOcupacaoFormal"] },
	{ label: "CEP", field: "cep" },
	{ label: "Município", field: "cmbMunicipioEndereco" },
	{ label: "Município", field: "cmbMunicipioAgenciaRelacionamento" },
	{ label: "Bairro", field: "bairro" },
	{ label: "Logradouro", field: "cmbTipoLogradouro" },
	{ label: "Rua", field: "logradouro" },
	{ label: "Complemento", field: "complemento" },
	{ label: "Número", field: "numero" },
	{ label: "Tipo de imóvel", field: "cmbTipoImovel" },
	{ label: "Ocupação do imóvel", field: "cmbTipoOcupacaoImovel" },
	{
		label: "Comprovante de residência",
		fields: ["comprovanteResidenciaMes", "comprovanteResidenciaAno"],
	},
	{ label: "Telefone de contato", fields: ["dddRes", "telefoneRes"] },
	{ label: "Telefone celular", fields: ["dddCel", "telefoneCel"] },
	{ label: "E-mail", field: "email" },
	{ label: "Características da renda", field: "cmbCaracteristicaRenda" },
	{ label: "Tipo de renda", field: "cmbCnpj_cpf" },
	{ label: "CPF", field: "numeroCpf" },
	{ label: "CNPJ", field: "numeroCnpj" },
	{ label: "Nome da fonte pagadora", field: "fontePagadora" },
	{ label: "Data de admissão", field: "dataAdmissao" },
	{ label: "Tempo no emprego anterior - Anos", field: "empregoAnteriorAnos" },
	{
		label: "Tempo no emprego anterior - Meses",
		field: "empregoAnteriorAnos",
	},
	{ label: "Renda bruta", field: "valorRendaBruta" },
	{ label: "Renda líquida", field: "valorRendaLiquida" },
	{
		label: "Documento de comprovante de renda",
		field: "cmbComprovanteRenda",
	},
	{ label: "Data do comprovante de renda", field: "cmbComprovanteRenda" },
	{ label: "IRPF", field: "iImposRendaRetFonte" },
	{ label: "Nome da atividade", field: "nomeAtividade" },
	{ label: "Data de início", field: "dataDeInicio" },
	{ label: "Renda líquida mensal", field: "rendaLiquidaMensal" },
	{ label: "Documentos de comprovação", field: "docCompAtivNComp" },
	{ label: "Documento", field: "proof_doc" },
	{ label: "Água e esgoto", field: "agua" },
	{ label: "Fatura cartão", field: "fatura" },
	{ label: "Previdência", field: "prev" },
	{ label: "Tv a cabo", field: "tv" },
];
